
import lazyload from "@/directives/lazyload";

import cougar from "@/assets/images/main/example/dating/cougar.png"
import dating from "@/assets/images/main/example/dating/dating.png"
import lavalife from "@/assets/images/main/example/dating/lavalife.png"
import mingle from "@/assets/images/main/example/dating/mingle.png"
import sexfinder from "@/assets/images/main/example/dating/sexfinder.png"
import sugar from "@/assets/images/main/example/dating/sugar.png"
import validate from "@/assets/images/main/example/dating/validate.png"
import want from "@/assets/images/main/example/dating/want.png"
import xdating from "@/assets/images/main/example/dating/xdating.png"
import xmatch from "@/assets/images/main/example/dating/xmatch.png"

export default {
  data() {
    return {
      images: {
        cougar,
        dating,
        lavalife,
        mingle,
        sexfinder,
        sugar,
        validate,
        want,
        xdating,
        xmatch
      },
    };
  },
  directives: {
    lazyload,
  },
};
